module.exports = __webpack_public_path__ + "img/rockstar.9f2b7b98.svg";